import React from "react";
import { MenuItem, TextField } from "@mui/material";
export default function PkCommonInfo(props) {
  const [error, errorSet] = React.useState(null);
  const [state, stateSet] = React.useState(props.format(props.value));
  const { validate, format, update, options, ...other } = props;
  return (
    <TextField
      {...other}
      {...error}
      variant={props.variant ? props.variant : "filled"}
      value={state}
      rows={4}
      key={`${props.name}`}
      sx={{ m: 0, width: "100%", svg: { color: "background.default" } }}
      inputProps={{
        autoComplete: "new-password",
      }}
      InputLabelProps={{
        shrink: true,
      }}
      InputProps={{
        disableUnderline: true,
        sx: {
          "& .MuiInputBase-root": {
            p: 0,
          },
          "& .MuiInputBase-input": {
            py: 0.5,
            px: 1.5,
          },
        },
      }}
      onChange={(e) => {
        if (error) {
          errorSet(null);
        }
        try {
          props.validate(e.target.value);
        } catch (e) {
          if (e instanceof Error) {
            errorSet({ error: true, helperText: e.message });
          }
        }
        stateSet(e.target.value);
      }}
      onKeyUp={(e) => {
        if (e.key === "Enter") {
          ((_e) => _e.blur())(e.target);
        }
      }}
      onBlur={(e) => {
        if (error) {
          e.target.focus();
          return;
        }
        ((r) => {
          stateSet(r);
          props.update(r);
        })(props.format(e.target.value));
      }}
    >
      {options
        ? options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))
        : null}
    </TextField>
  );
}
